export default {
  state: {
    delivery_address: null,
    delivery_address_show: false
  },
  mutations: {
    setGoodAddress: function setGoodAddress(state, data) {
      state.delivery_address = data;
    },
    setGood_delivery_address_show: function setGood_delivery_address_show(state, data) {
      state.delivery_address_show = data;
    }
  },
  actions: {},
  getters: {}
};